var _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 395.631,
    stroke: "#FBD904",
    strokeOpacity: 0.4,
    strokeWidth: 4.85437
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 497.573,
    stroke: "#FBD904",
    strokeOpacity: 0.2,
    strokeWidth: 4.85437
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.809,
    cy: 499.191,
    r: 268.608,
    stroke: "#FBD904",
    strokeOpacity: 0.6,
    strokeWidth: 4.85437
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 149.676,
    stroke: "#FBD904",
    strokeOpacity: 0.8,
    strokeWidth: 4.85437
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.809,
    cy: 499.191,
    r: 59.8705,
    stroke: "#FBD904",
    strokeWidth: 4.85437
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.86410a9b8e5157610583809f3e798f8d.svg";
export { ForwardRef as ReactComponent };